'use client';

import React from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import StorageCard from './StorageCard';
import { workloadDescTitleClassName, workloadDescClassName } from './Styles';
import RedirectButton from './RedirectButton';

export default function Storage() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  const parallelStorageDescription = (
    <>
      <p className="mb-m">
        {t('public.site.pricing.storage.parallel.desc', {})}
      </p>
      <div className="mb-m pl-3xs">
        <div className="flex gap-2xs mb-0">
          <span>•</span>
          <span>{t('public.site.pricing.storage.parallel.example1', {})}</span>
        </div>
        <div className="flex gap-2xs">
          <span>•</span>
          <span>{t('public.site.pricing.storage.parallel.example2', {})}</span>
        </div>
      </div>
      <p>
        {t('public.site.pricing.storage.gib.note', {})}
      </p>
    </>
  );

  const objectStorageDescription = (
    <>
      <p className="mb-m">
        {t('public.site.pricing.storage.object.desc', {})}
      </p>
      <div className="mb-m pl-3xs">
        <div className="flex gap-2xs mb-0">
          <span>•</span>
          <span>{t('public.site.pricing.storage.object.example1', {})}</span>
        </div>
        <div className="flex gap-2xs">
          <span>•</span>
          <span>{t('public.site.pricing.storage.object.example2', {})}</span>
        </div>
      </div>
      <p>
        {t('public.site.pricing.storage.gib.note', {})}
      </p>
    </>
  );

  return (
    <>
      <div className="flex flex-col gap-3xl items-center">
        <span className={workloadDescTitleClassName}>
          {t('public.site.pricing.workload.storage.title', {})}
        </span>
        <div className="flex flex-col items-center">
          <span className={workloadDescClassName}>
            {t('public.site.pricing.workload.storage.desc', {})}
          </span>
        </div>
      </div>
      <RedirectButton
        className="mt-3xl"
        label={t('public.site.contact.us', {})}
      />
      <div className="flex flex-row w-full mt-9xl gap-5xl">
        <StorageCard
          title={t('public.site.pricing.storage.parallel.title', {})}
          price="$0.15"
          unit={t('public.site.pricing.unit.GiB', {})}
          description={parallelStorageDescription}
        />
        <StorageCard
          title={t('public.site.pricing.storage.object.title', {})}
          price="$0.03"
          unit={t('public.site.pricing.unit.GiB', {})}
          description={objectStorageDescription}
        />
      </div>
    </>
  );
}
